export const createVirtualElement = (pointRef) => ({
    getBoundingClientRect: () => {
        const { x, y } = pointRef.current;
        return {
            width: 0,
            height: 0,
            top: y,
            right: x,
            bottom: y,
            left: x,
            // These are just needed to match ClientRect | DOMRect shape.
            x,
            y,
            toJSON: () => { }
        };
    }
});
export const registerVirtualInstance = ({ instance, targetElement, virtualElement, isTouch, initialCoordinatesRef }) => {
    const clientRect = virtualElement.getBoundingClientRect();
    virtualElement.getBoundingClientRect = () => clientRect;
    const updateVirtualElement = (e) => {
        e.preventDefault();
        const { clientX: x, clientY: y } = isTouch ? e.changedTouches[0] : e;
        clientRect.top = y;
        clientRect.bottom = y;
        clientRect.left = x;
        clientRect.right = x;
        initialCoordinatesRef.current = { x, y };
        instance.update();
    };
    if (isTouch) {
        targetElement.addEventListener("touchstart", updateVirtualElement);
        targetElement.addEventListener("touchmove", updateVirtualElement);
    }
    else {
        targetElement.addEventListener("mousemove", updateVirtualElement);
    }
    const destroyVirtualElement = () => {
        if (isTouch) {
            targetElement.removeEventListener("touchstart", updateVirtualElement);
            targetElement.removeEventListener("touchmove", updateVirtualElement);
        }
        targetElement.removeEventListener("mousemove", updateVirtualElement);
    };
    return destroyVirtualElement;
};
